import { wrap } from '../helper';

const BODY_TEXT = document.querySelectorAll('.ce__bodytext');
const CONTENT_TABLE = document.querySelectorAll('.contenttable');


CONTENT_TABLE && CONTENT_TABLE.forEach((el) => {
	const wrapper = document.createElement('div');
	wrapper.classList.add('table-wrapper');

	wrap(el, wrapper);
});

BODY_TEXT && BODY_TEXT.forEach((el) => {
	let bodyTextHasTable = false;

	el.querySelectorAll('table').forEach((children) => {
		if (children.tagName === 'TABLE') bodyTextHasTable = true;
	})

	if (bodyTextHasTable) {
		el.closest('.ce__content').classList.add('has-table');
	}
})